import type { FC } from 'react';

interface HorizontalBarIndicatorProps {
  label: string;
  value: number;
  maxValue: number;
}

const HorizontalBarIndicator: FC<HorizontalBarIndicatorProps> = ({ label, value, maxValue }) => {
  const percentage = maxValue > 0 ? Math.max(4, Math.round((value / maxValue) * 100)) : 0;

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium text-gray-700 truncate">{label}</p>
        <p className="text-sm font-semibold text-gray-900">{value}</p>
      </div>
      <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-[#681628] transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default HorizontalBarIndicator;
